/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  SET_NAVIGATION_OPEN
} from './types';
import initialState from './initialState';

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_NAVIGATION_OPEN:
      return {
        ...state,
        isOpen: action.isOpen
      };

    default:
      return state;
  }
};

export default reducer;
